import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Über Uns", href: "/#ueber-uns" },
  { label: "Vorteile", href: "/#vorteile" },
  { label: "Kontakt", href: "/kontakt" },
];

const IMPRESSUM = () => (
  <div className="font-body text-reinert-grey leading-relaxed">
    <h1 className="font-display font-extrabold text-4xl md:text-5xl text-reinert-grey-dark mb-8">Impressum</h1>
    
    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Angaben gemäß § 5 TMG</h2>
    <p className="mb-4">
      Malerbetrieb Reinert<br />
      Geschäftsführer: Daniel Josten<br />
      Walporzheimer Str. 100<br />
      53474 Bad Neuenahr-Ahrweiler
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Kontakt</h2>
    <p className="mb-4">
      Telefon: 02641 / 205474<br />
      E-Mail: info@malerbetrieb-reinert.de
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Berufsbezeichnung und berufsrechtliche Regelungen</h2>
    <p className="mb-4">
      Berufsbezeichnung: Maler und Lackierer<br />
      Zuständige Kammer: Handwerkskammer Koblenz<br />
      Verliehen in: Deutschland
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Streitschlichtung</h2>
    <p className="mb-4">
      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-reinert-blue-DEFAULT underline">https://ec.europa.eu/consumers/odr</a>.<br />
      Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>
    <p className="mb-4">
      Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Internetarchitektur</h2>
    <p className="mb-4">
      NetzTurm GmbH & Co. KG.<br />
      Am Johannisberg 73<br />
      53474 Bad Neuenahr<br />
      E-Mail: <a href="mailto:mail@netzturm.com" className="text-reinert-blue-DEFAULT underline">mail@netzturm.com</a>
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Haftung für Inhalte</h2>
    <p className="mb-4">
      Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
    </p>
    <p className="mb-4">
      Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Haftung für Links</h2>
    <p className="mb-4">
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
    </p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">Urheberrecht</h2>
    <p className="mb-4">
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
    </p>
  </div>
);

const DATENSCHUTZ = () => (
  <div className="font-body text-reinert-grey leading-relaxed">
    <h1 className="font-display font-extrabold text-4xl md:text-5xl text-reinert-grey-dark mb-8">Datenschutzerklärung</h1>
    
    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">1. Datenschutz auf einen Blick</h2>
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Allgemeine Hinweise</h3>
    <p className="mb-4">Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
    
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Datenerfassung auf unserer Website</h3>
    <p className="mb-2"><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong></p>
    <p className="mb-4">Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.</p>
    
    <p className="mb-2"><strong>Wie erfassen wir Ihre Daten?</strong></p>
    <p className="mb-4">Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
    
    <p className="mb-2"><strong>Wofür nutzen wir Ihre Daten?</strong></p>
    <p className="mb-4">Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
    
    <p className="mb-2"><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong></p>
    <p className="mb-4">Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen.</p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">2. Allgemeine Hinweise und Pflichtinformationen</h2>
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Datenschutz</h3>
    <p className="mb-4">Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
    
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Hinweis zur verantwortlichen Stelle</h3>
    <p className="mb-4">
      Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
      Malerbetrieb Reinert<br />
      Geschäftsführer: Daniel Josten<br />
      Walporzheimer Str. 100<br />
      53474 Bad Neuenahr-Ahrweiler<br /><br />
      Telefon: 02641 / 205474<br />
      E-Mail: info@malerbetrieb-reinert.de
    </p>

    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
    <p className="mb-4">Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.</p>

    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
    <p className="mb-4">Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat.</p>

    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">SSL- bzw. TLS-Verschlüsselung</h3>
    <p className="mb-4">Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">3. Datenerfassung auf unserer Website</h2>
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Cookies</h3>
    <p className="mb-4">Diese Website verwendet keine Cookies zu Tracking- oder Analysezwecken.</p>

    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Server-Log-Dateien</h3>
    <p className="mb-2">Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
    <ul className="list-disc ml-6 mb-4 space-y-1">
      <li>Browsertyp und Browserversion</li>
      <li>verwendetes Betriebssystem</li>
      <li>Referrer URL</li>
      <li>Hostname des zugreifenden Rechners</li>
      <li>Uhrzeit der Serveranfrage</li>
      <li>IP-Adresse</li>
    </ul>
    <p className="mb-4">Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.</p>

    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Kontaktformular</h3>
    <p className="mb-4">Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
    <p className="mb-4">Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen.</p>

    <h2 className="font-display font-bold text-xl text-reinert-grey-dark mt-8 mb-3">4. Plugins und Tools</h2>
    <h3 className="font-display font-bold text-lg text-reinert-grey-dark mt-6 mb-2">Google Web Fonts</h3>
    <p className="mb-4">Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts. Die Schriftarten sind lokal auf unserem Server gespeichert. Eine Verbindung zu Servern von Google findet nicht statt. Es werden keine Daten an Dritte übermittelt.</p>
  </div>
);

export default function LegalPage({ type }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isImpressum = type === "impressum";
  const title = isImpressum ? "Impressum" : "Datenschutzerklärung";

  useEffect(() => {
    document.title = `${title} | Malerbetrieb Reinert`;
    window.scrollTo(0, 0);
  }, [title]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <div className="min-h-screen bg-white" data-testid={`page-${type}`}>
      {/* Navigation */}
      <nav className={`nav-bar fixed top-0 left-0 right-0 z-50 bg-white ${scrolled ? "scrolled" : ""}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 no-underline">
            <img src="/logo-reinert.webp" alt="Malerbetrieb Reinert" style={{ height: 72, width: 'auto' }} />
          </Link>
          <div className="hidden lg:flex items-center gap-10">
            {NAV_LINKS.map((link) => (
              <Link key={link.href} to={link.href} className="nav-link bg-transparent border-none font-body no-underline">{link.label}</Link>
            ))}
            <Link to="/kontakt" className="btn-primary no-underline">
              <Phone className="w-4 h-4" /> Beratung anfragen
            </Link>
          </div>
          <button className="lg:hidden bg-transparent border-none cursor-pointer p-2 text-reinert-grey-dark" onClick={() => setMenuOpen(true)}>
            <Menu className="w-7 h-7" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="flex justify-end p-6">
          <button onClick={() => setMenuOpen(false)} className="bg-transparent border-none cursor-pointer text-white"><X className="w-8 h-8" /></button>
        </div>
        <div className="flex flex-col items-start px-10 gap-6 mt-8">
          {NAV_LINKS.map((link) => (
            <Link key={link.href} to={link.href} onClick={() => setMenuOpen(false)} className="mobile-menu-link bg-transparent border-none no-underline">{link.label}</Link>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 pt-32 pb-16 md:pt-36 md:pb-24">
        {isImpressum ? <IMPRESSUM /> : <DATENSCHUTZ />}
      </div>

      {/* Footer */}
      <footer className="bg-reinert-grey-dark py-8 px-6 text-center">
        <div className="flex justify-center gap-6 mb-4">
          <Link to="/impressum" className="text-white/50 text-xs font-body hover:text-white transition-colors no-underline">Impressum</Link>
          <Link to="/datenschutz" className="text-white/50 text-xs font-body hover:text-white transition-colors no-underline">Datenschutz</Link>
          <Link to="/kontakt" className="text-white/50 text-xs font-body hover:text-white transition-colors no-underline">Kontakt</Link>
        </div>
        <p className="text-white/30 font-body text-xs">&copy; {new Date().getFullYear()} Malerbetrieb Reinert. Alle Rechte vorbehalten.</p>
      </footer>
    </div>
  );
}
